module.exports = __webpack_public_path__ + "assets/img/btn-view-3f4c354a.png";